/**
 * @file 模型库详情页 hooks
 * @author FengGuang(fengguang01@baidu.com)
 */
import {useEffect, useMemo, useState} from 'react';
import {fetchGetModeCategoryId, fetchGetModelInfo} from '../../api/pages/modelBaseApi';

import {
    IModelBaseDetail
} from './type';


// 从 url 中解析本页数据关联的key
const getParamsFromUrl = () => {
    const pathDetailUrl = window.location.pathname;
    const theUrlSearchs = new URLSearchParams(window.location.search.slice(1));
    const searchDetailUrl = theUrlSearchs.get('detailUrl');
    const requestUrl = searchDetailUrl || pathDetailUrl || undefined;

    return {
        requestUrl
    };
};

// 预请求
let preRequest: any = {};
if (window) {
    const serverRenderData = (window as any).serverRenderData;
    if (serverRenderData) {
        preRequest.fetchGetModelInfo = Promise.resolve({body: serverRenderData});
    }
    else {
        preRequest.fetchGetModelInfo = fetchGetModelInfo(getParamsFromUrl());
    }
    const cateoryIdData = (window as any).categoryId;
    if (cateoryIdData) {
        preRequest.fetchGetModeCategoryId = Promise.resolve({body: cateoryIdData});
    }
    else {
        preRequest.fetchGetModeCategoryId = fetchGetModeCategoryId(getParamsFromUrl());
    }
}

export function useModelDetail() {
    const modelDetailState = useState<IModelBaseDetail>({
        id: '',
        name: '',
        summary: '',
        type: '',
        application: '',
        getModelUrl: '',
        getPaddlePaddleUrl: '',
        onlineRunUrl: '',
        paperUrl: '',
        modelStructuralDiagramUrl: '',
        detail: ''
    });
    const setModelDetail = modelDetailState[1];

    useEffect(() => {
        (async (): Promise<void> => {
            const fetchFunc = preRequest.fetchGetModelInfo || fetchGetModelInfo(getParamsFromUrl());
            delete preRequest.fetchGetModelInfo;

            let res;
            try {
                res = await fetchFunc;
            }
            catch (err: any) {
                // ignore
            }
            if (res) {
                const pageData: any = res.body.result.pageData || {};
                const theData = pageData[0]?.options || {};

                setModelDetail({
                    id: theData.id,
                    name: theData.name,
                    summary: theData.summary,
                    type: theData.type,
                    application: theData.application,
                    getModelUrl: theData.getModelUrl,
                    getPaddlePaddleUrl: theData.getPaddlePaddleUrl,
                    onlineRunUrl: theData.onlineRunUrl,
                    paperUrl: theData.paperUrl,
                    modelStructuralDiagramUrl: theData.modelStructuralDiagramUrl,
                    detail: theData.detail
                });
            }
        })();
    }, [setModelDetail]);

    return modelDetailState;
}

export const useCategoryId = () => {
    const state = useState<string>('');
    const setCateoryId = state[1];

    useEffect(() => {
        (async (): Promise<void> => {
            const fetchFunc = preRequest.fetchGetModeCategoryId || fetchGetModeCategoryId(getParamsFromUrl());
            delete preRequest.fetchGetModelInfo;

            let res;
            try {
                res = await fetchFunc;
            }
            catch (err: any) {
                // ignore
            }
            if (res) {
                const cateoryId: string = res.body.result || '';
                setCateoryId('' + cateoryId);
            }
        })();
    }, [setCateoryId]);

    return state;
};

export default function useModelBaseDetailHooks() {
    const [modelDetail] = useModelDetail();
    const [cateoryId] = useCategoryId();

    const backToModelBaseBreadcrumbUrl = useMemo(() => {
        if (modelDetail) {
            const thisSearch = new URLSearchParams();
            thisSearch.set('categoryId', cateoryId);
            return `/modelbase?${thisSearch.toString()}`;
        }
        return '';
    }, [modelDetail, cateoryId]);

    return {
        modelDetail,
        cateoryId,
        backToModelBaseBreadcrumbUrl
    };
};
